class Mouse {
  constructor() {
    this.x = 0;
    this.y = 0;
    document.addEventListener('mousemove', this);
  }

  handleEvent(event) {
    const isMousemove = event.type === 'mousemove';

    if (isMousemove) {
      this.x = event.pageX;
      this.y = event.pageY;
      window.mouse = { x: this.x, y: this.y };
    }
  }
}

export default {
  monitor() {
    if (!window.mouse) {
      window.mouse = new Mouse();
    }
  },
};
